import React, { useState, useMemo } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { CaretDown, CaretRight } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import { trackHomeClickViewAllProjects } from '../../../analytics';

import { Button } from '../../../components/general';

import { URL } from '../../../constants';
import { Event } from '../../../types';
import { isEmpty, scrollToTop } from '../../../utils';

import ProjectBlock from './projectBlock';

const ProjectsContainer = (props: {
  heading: string;
  events: Event[];
  isCollapse?: boolean;
  hideHeading?: boolean;
  projectNumLimit?: number;
}) => {
  const {
    heading,
    events,
    isCollapse,
    hideHeading,
    projectNumLimit = Infinity,
  } = props;

  const [collapseState, setCollapseState] = useState<boolean>(true);

  const navigate = useNavigate();

  const eventsUpd = useMemo(() => {
    return events.length > projectNumLimit
      ? events.slice(0, projectNumLimit - 1)
      : events;
  }, [events, projectNumLimit]);

  if (isEmpty(events)) return null;

  const isShow = isCollapse ? collapseState : true;

  return (
    <div className="w-full flex flex-col gap-4">
      <Accordion
        expanded={isShow}
        onChange={() => setCollapseState(!collapseState)}
        className="shadow-none"
        disableGutters
        sx={{
          '.MuiAccordionSummary-root': { minHeight: 0 },
          ':before': { display: 'none' },
        }}
      >
        <AccordionSummary
          className="p-0 cursor-default"
          sx={{ '.MuiAccordionSummary-content': { margin: 0 } }}
        >
          {isCollapse ? (
            <div className="w-full flex items-center p-2 gap-2 rounded-md cursor-pointer hover:bg-grey-100">
              <div className="text-[1.1rem] leading-none">
                {isShow ? <CaretDown /> : <CaretRight />}
              </div>

              <h5>{heading}</h5>
            </div>
          ) : (
            !hideHeading && <h5>{heading}</h5>
          )}
        </AccordionSummary>

        <AccordionDetails className="flex flex-wrap mt-4 p-0 gap-4 lg:gap-7">
          {eventsUpd.map((event) => (
            <ProjectBlock event={event} key={event.eventId} />
          ))}

          {events.length > projectNumLimit && (
            <Button
              onClick={() => {
                navigate(URL.DASH_PROJECTS);
                scrollToTop();
                trackHomeClickViewAllProjects(heading);
              }}
              variant="custom"
              colour="grey-outline-salmon"
              className="w-[var(--project-block-width)] h-min aspect-video flex items-center justify-center text-lg uppercase rounded-md"
            >
              View All
            </Button>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ProjectsContainer;
